import { render, staticRenderFns } from "./ActiveMng.vue?vue&type=template&id=054fd990"
import script from "./ActiveMng.vue?vue&type=script&lang=js"
export * from "./ActiveMng.vue?vue&type=script&lang=js"
import style0 from "./ActiveMng.vue?vue&type=style&index=0&id=054fd990&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports